export const alertActions = {
	ALERT_ERROR: 'error',
	ALERT_INFO: 'info',
	ALERT_SUCCESS: 'success',
	CLEAR_ALERT: 'CLEAR_ALERT'
};